import React, { useEffect, useRef, useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import ModalBox from "../modals/ModalBox";
import { getselectedIds, isEmptyObject } from "../../utils/handler";
import NoData from "../../Pages/Relationship/DetailsContent/NoData";
import FormFields from "./FormFields";

function PopupSelect({ name, label, rules, options, className, showImage, showSearch, onOpen, onClose, hasData=true, selectFunction, onConfirm, selectedOptionObj,dialogClassName }) {
  
  const searchInputRef = useRef(null);
  const {
    control,
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useFormContext();
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Add state for search term
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedOption, setSelectedOption] = useState({});
  
  const openModal = () => {
    setSearchTerm('');
    setShowModal(true);
    onOpen && onOpen();
  };

  const handleSelect = (option) => {
    setSelectedValue(option.id);
    selectFunction && selectFunction(option);
    option.optFunction && option.optFunction();
  };

  const handleConfirm = () => {
    const selectedopt = options.find((opt) => opt.id === selectedValue);
    console.log('selectedopt',selectedopt);
    setSelectedOption(selectedopt);
    onConfirm && onConfirm(selectedopt);
    onConfirm || setValue(name, selectedValue);
    setShowModal(false);
    setSearchTerm('');
    trigger(name);
  };

  useEffect(() => {
    if(selectedOptionObj){
      // setSelectedOption(selectedOptionObj);   // shows name before submitting
      setSelectedValue(selectedOptionObj.id);
    }
  }, [selectedOptionObj])
  
  useEffect(() => {
    if (showModal && showSearch && searchInputRef.current) {
      setTimeout(() => {
        searchInputRef.current.focus();
      }, 100);
    }
  }, [showModal, showSearch]);
  // useEffect(() => {
    // setSelectedOption({})  // selected option not showing
  // }, [options])

  return (
    <div className={className}>
      {(isEmptyObject(selectedOption) || !showImage) && <label htmlFor={name} className="form-label">
        {label}
      </label>}

      <Controller
        name={name}
        control={control}
        defaultValue=""
        rules={rules}
        render={({ field }) => (
          <div className="row">
            <div onClick={() => openModal()}>
              {!isEmptyObject(selectedOption) ? (
                showImage ? <div className="d-flex align-items-center justify-content-center flex-wrap text-center ">
                  <div>
                    <div className="profile-img">
                      <img
                        src={selectedOption.img}
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                    <div className="mt-2 mt-md-0 ms-lg-1 text-lg-start rltnshp-txt">
                      <p className="mb-1 text-center" style={{fontSize: '20px', fontWeight: '700', margin: '0px !important'}}>{selectedOption.name || watch(name)}</p>
                      {selectedOption.subtext && (
                        <small className="d-block text-center">
                          {selectedOption.subtext}
                        </small>
                      )}
                    </div>
                  </div>

                </div> :
                <input className="form-control" value={selectedOption.name} readOnly/>
              ) : (
                <input className="form-control" value={watch(name)} readOnly/>
              )}
              {/* <pre>{JSON.stringify(selectedOption, null, 2)}</pre> */}
            </div>
            <ModalBox
              isShow={showModal}
              handleClose={() => {
                onClose && onClose();
                setShowModal(false);
              }}
              modalSize="md"
              hasData={hasData}
              dialogClassName={dialogClassName || 'dif-modal'}
              // hideClose={true}
            >
              <div className="text-center position-relative">
                <h3 className="modal-title mb-3 mt-0">{label}</h3>
              </div>
              {!!showSearch && (
              <div className="row">
               
                <div className="col-12 mb-3">
                  <input
                    type="text"
                    ref={searchInputRef}
                    className="form-control"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              
              </div>
              )}
               <div className="select-state ">
              <div className="row">
             
                {options?.length > 0 ? (
                  (() => {
                    const filteredOptions = options.filter((option) =>
                      option.name.toLowerCase().includes(searchTerm.toLowerCase()) || option.prefix?.toLowerCase().includes(searchTerm.toLowerCase())
                    );

                    return filteredOptions.length > 0 ? (
                      filteredOptions.map((option, index) => (
                        <div key={index} className="col-12">
                          <div className="state-slt "  onClick={() => handleSelect(option)}>
                            <div className="">
                              <label
                                className="form-check-label ms-1"
                                htmlFor={name + `-radio-` + option.id}
                              >
                                <div className="d-flex align-items-center justify-content-center justify-content-md-start flex-wrap text-center ">
                                  {option.img && <div className="profile-img">
                                    <img
                                      src={option.img}
                                      style={{ width: "35px", height: "35px" }}
                                    />
                                  </div>}
                                  <div className="mt-2 mt-md-0 ms-lg-1 text-lg-start rltnshp-txt">
                                    <p className="mb-1">{option.name}</p>
                                    {option.subtext && (
                                      <small className="d-block">
                                        {option.subtext}
                                      </small>
                                    )}
                                  </div>
                                </div>
                              </label>
                            </div>
                            <div className="">
                              <div className="form-check form-checked">
                                <input
                                  name={name}
                                  type="radio"
                                  value={option.id}
                                  className="form-check-input"
                                  id={name + `-radio-` + option.id}
                                  // onChange={() => handleSelect(option)}
                                  checked={selectedValue === option.id}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <NoData />
                    );
                  })()
                ) : (
                  <NoData />
                )}
                
              </div>
</div>
              <div className="row">
                <div className="col-12">
                  <button
                    type="button"
                    className="btn btn-primary rounded-pill w-100 my-2 p-2"
                    onClick={handleConfirm}
                    disabled={!selectedValue}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </ModalBox>
          </div>
        )}
      />

      {errors[name] && <span className="error">{errors[name].message}</span>}
    </div>
  );
}

export default PopupSelect;
